function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, i) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = i() : "function" == typeof define && define.amd ? define(i) : (t = "undefined" != typeof globalThis ? globalThis : t || self).RBush = i();
}(this, function () {
  "use strict";

  function t(e, h) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : e.length - 1;
    var a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : n;

    for (; s > r;) {
      if (s - r > 600) {
        var _i = s - r + 1,
            _n2 = h - r + 1,
            _o2 = Math.log(_i),
            _l2 = .5 * Math.exp(2 * _o2 / 3),
            _c = .5 * Math.sqrt(_o2 * _l2 * (_i - _l2) / _i) * (_n2 - _i / 2 < 0 ? -1 : 1);

        t(e, h, Math.max(r, Math.floor(h - _n2 * _l2 / _i + _c)), Math.min(s, Math.floor(h + (_i - _n2) * _l2 / _i + _c)), a);
      }

      var _n = e[h];
      var _o = r,
          _l = s;

      for (i(e, r, h), a(e[s], _n) > 0 && i(e, r, s); _o < _l;) {
        for (i(e, _o, _l), _o++, _l--; a(e[_o], _n) < 0;) {
          _o++;
        }

        for (; a(e[_l], _n) > 0;) {
          _l--;
        }
      }

      0 === a(e[r], _n) ? i(e, r, _l) : (_l++, i(e, _l, s)), _l <= h && (r = _l + 1), h <= _l && (s = _l - 1);
    }
  }

  function i(t, i, n) {
    var e = t[i];
    t[i] = t[n], t[n] = e;
  }

  function n(t, i) {
    return t < i ? -1 : t > i ? 1 : 0;
  }

  function e(t, i, n) {
    if (!n) return i.indexOf(t);

    for (var _e = 0; _e < i.length; _e++) {
      if (n(t, i[_e])) return _e;
    }

    return -1;
  }

  function h(t, i) {
    r(t, 0, t.children.length, i, t);
  }

  function r(t, i, n, e, h) {
    h || (h = d(null)), h.minX = 1 / 0, h.minY = 1 / 0, h.maxX = -1 / 0, h.maxY = -1 / 0;

    for (var _r = i; _r < n; _r++) {
      var _i2 = t.children[_r];
      s(h, t.leaf ? e(_i2) : _i2);
    }

    return h;
  }

  function s(t, i) {
    return t.minX = Math.min(t.minX, i.minX), t.minY = Math.min(t.minY, i.minY), t.maxX = Math.max(t.maxX, i.maxX), t.maxY = Math.max(t.maxY, i.maxY), t;
  }

  function a(t, i) {
    return t.minX - i.minX;
  }

  function o(t, i) {
    return t.minY - i.minY;
  }

  function l(t) {
    return (t.maxX - t.minX) * (t.maxY - t.minY);
  }

  function c(t) {
    return t.maxX - t.minX + (t.maxY - t.minY);
  }

  function m(t, i) {
    var n = Math.max(t.minX, i.minX),
        e = Math.max(t.minY, i.minY),
        h = Math.min(t.maxX, i.maxX),
        r = Math.min(t.maxY, i.maxY);
    return Math.max(0, h - n) * Math.max(0, r - e);
  }

  function f(t, i) {
    return t.minX <= i.minX && t.minY <= i.minY && i.maxX <= t.maxX && i.maxY <= t.maxY;
  }

  function u(t, i) {
    return i.minX <= t.maxX && i.minY <= t.maxY && i.maxX >= t.minX && i.maxY >= t.minY;
  }

  function d(t) {
    return {
      children: t,
      height: 1,
      leaf: !0,
      minX: 1 / 0,
      minY: 1 / 0,
      maxX: -1 / 0,
      maxY: -1 / 0
    };
  }

  function x(i, n, e, h, r) {
    var s = [n, e];

    for (; s.length;) {
      if ((e = s.pop()) - (n = s.pop()) <= h) continue;

      var _a = n + Math.ceil((e - n) / h / 2) * h;

      t(i, _a, n, e, r), s.push(n, _a, _a, e);
    }
  }

  return /*#__PURE__*/function () {
    function _class() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 9;

      _classCallCheck(this, _class);

      this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), this.clear();
    }

    _createClass(_class, [{
      key: "all",
      value: function all() {
        return this._all(this.data, []);
      }
    }, {
      key: "search",
      value: function search(t) {
        var i = this.data;
        var n = [];
        if (!u(t, i)) return n;
        var e = this.toBBox,
            h = [];

        for (; i;) {
          for (var _r2 = 0; _r2 < i.children.length; _r2++) {
            var _s = i.children[_r2],
                _a2 = i.leaf ? e(_s) : _s;

            u(t, _a2) && (i.leaf ? n.push(_s) : f(t, _a2) ? this._all(_s, n) : h.push(_s));
          }

          i = h.pop();
        }

        return n;
      }
    }, {
      key: "collides",
      value: function collides(t) {
        var i = this.data;
        if (!u(t, i)) return !1;
        var n = [];

        for (; i;) {
          for (var _e2 = 0; _e2 < i.children.length; _e2++) {
            var _h = i.children[_e2],
                _r3 = i.leaf ? this.toBBox(_h) : _h;

            if (u(t, _r3)) {
              if (i.leaf || f(t, _r3)) return !0;
              n.push(_h);
            }
          }

          i = n.pop();
        }

        return !1;
      }
    }, {
      key: "load",
      value: function load(t) {
        if (!t || !t.length) return this;

        if (t.length < this._minEntries) {
          for (var _i3 = 0; _i3 < t.length; _i3++) {
            this.insert(t[_i3]);
          }

          return this;
        }

        var i = this._build(t.slice(), 0, t.length - 1, 0);

        if (this.data.children.length) {
          if (this.data.height === i.height) this._splitRoot(this.data, i);else {
            if (this.data.height < i.height) {
              var _t = this.data;
              this.data = i, i = _t;
            }

            this._insert(i, this.data.height - i.height - 1, !0);
          }
        } else this.data = i;
        return this;
      }
    }, {
      key: "insert",
      value: function insert(t) {
        return t && this._insert(t, this.data.height - 1), this;
      }
    }, {
      key: "clear",
      value: function clear() {
        return this.data = d([]), this;
      }
    }, {
      key: "remove",
      value: function remove(t, i) {
        if (!t) return this;
        var n = this.data;
        var h = this.toBBox(t),
            r = [],
            s = [];
        var a, o, l;

        for (; n || r.length;) {
          if (n || (n = r.pop(), o = r[r.length - 1], a = s.pop(), l = !0), n.leaf) {
            var _h2 = e(t, n.children, i);

            if (-1 !== _h2) return n.children.splice(_h2, 1), r.push(n), this._condense(r), this;
          }

          l || n.leaf || !f(n, h) ? o ? (a++, n = o.children[a], l = !1) : n = null : (r.push(n), s.push(a), a = 0, o = n, n = n.children[0]);
        }

        return this;
      }
    }, {
      key: "toBBox",
      value: function toBBox(t) {
        return t;
      }
    }, {
      key: "compareMinX",
      value: function compareMinX(t, i) {
        return t.minX - i.minX;
      }
    }, {
      key: "compareMinY",
      value: function compareMinY(t, i) {
        return t.minY - i.minY;
      }
    }, {
      key: "toJSON",
      value: function toJSON() {
        return this.data;
      }
    }, {
      key: "fromJSON",
      value: function fromJSON(t) {
        return this.data = t, this;
      }
    }, {
      key: "_all",
      value: function _all(t, i) {
        var n = [];

        for (; t;) {
          t.leaf ? i.push.apply(i, _toConsumableArray(t.children)) : n.push.apply(n, _toConsumableArray(t.children)), t = n.pop();
        }

        return i;
      }
    }, {
      key: "_build",
      value: function _build(t, i, n, e) {
        var r = n - i + 1;
        var s,
            a = this._maxEntries;
        if (r <= a) return s = d(t.slice(i, n + 1)), h(s, this.toBBox), s;
        e || (e = Math.ceil(Math.log(r) / Math.log(a)), a = Math.ceil(r / Math.pow(a, e - 1))), s = d([]), s.leaf = !1, s.height = e;
        var o = Math.ceil(r / a),
            l = o * Math.ceil(Math.sqrt(a));
        x(t, i, n, l, this.compareMinX);

        for (var _h3 = i; _h3 <= n; _h3 += l) {
          var _i4 = Math.min(_h3 + l - 1, n);

          x(t, _h3, _i4, o, this.compareMinY);

          for (var _n3 = _h3; _n3 <= _i4; _n3 += o) {
            var _h4 = Math.min(_n3 + o - 1, _i4);

            s.children.push(this._build(t, _n3, _h4, e - 1));
          }
        }

        return h(s, this.toBBox), s;
      }
    }, {
      key: "_chooseSubtree",
      value: function _chooseSubtree(t, i, n, e) {
        for (; e.push(i), !i.leaf && e.length - 1 !== n;) {
          var _n4 = void 0,
              _e3 = 1 / 0,
              _s2 = 1 / 0;

          for (var _a3 = 0; _a3 < i.children.length; _a3++) {
            var _o3 = i.children[_a3],
                _c2 = l(_o3),
                _m = (h = t, r = _o3, (Math.max(r.maxX, h.maxX) - Math.min(r.minX, h.minX)) * (Math.max(r.maxY, h.maxY) - Math.min(r.minY, h.minY)) - _c2);

            _m < _s2 ? (_s2 = _m, _e3 = _c2 < _e3 ? _c2 : _e3, _n4 = _o3) : _m === _s2 && _c2 < _e3 && (_e3 = _c2, _n4 = _o3);
          }

          i = _n4 || i.children[0];
        }

        var h, r;
        return i;
      }
    }, {
      key: "_insert",
      value: function _insert(t, i, n) {
        var e = n ? t : this.toBBox(t),
            h = [],
            r = this._chooseSubtree(e, this.data, i, h);

        for (r.children.push(t), s(r, e); i >= 0 && h[i].children.length > this._maxEntries;) {
          this._split(h, i), i--;
        }

        this._adjustParentBBoxes(e, h, i);
      }
    }, {
      key: "_split",
      value: function _split(t, i) {
        var n = t[i],
            e = n.children.length,
            r = this._minEntries;

        this._chooseSplitAxis(n, r, e);

        var s = this._chooseSplitIndex(n, r, e),
            a = d(n.children.splice(s, n.children.length - s));

        a.height = n.height, a.leaf = n.leaf, h(n, this.toBBox), h(a, this.toBBox), i ? t[i - 1].children.push(a) : this._splitRoot(n, a);
      }
    }, {
      key: "_splitRoot",
      value: function _splitRoot(t, i) {
        this.data = d([t, i]), this.data.height = t.height + 1, this.data.leaf = !1, h(this.data, this.toBBox);
      }
    }, {
      key: "_chooseSplitIndex",
      value: function _chooseSplitIndex(t, i, n) {
        var e,
            h = 1 / 0,
            s = 1 / 0;

        for (var _a4 = i; _a4 <= n - i; _a4++) {
          var _i5 = r(t, 0, _a4, this.toBBox),
              _o4 = r(t, _a4, n, this.toBBox),
              _c3 = m(_i5, _o4),
              _f = l(_i5) + l(_o4);

          _c3 < h ? (h = _c3, e = _a4, s = _f < s ? _f : s) : _c3 === h && _f < s && (s = _f, e = _a4);
        }

        return e || n - i;
      }
    }, {
      key: "_chooseSplitAxis",
      value: function _chooseSplitAxis(t, i, n) {
        var e = t.leaf ? this.compareMinX : a,
            h = t.leaf ? this.compareMinY : o;
        this._allDistMargin(t, i, n, e) < this._allDistMargin(t, i, n, h) && t.children.sort(e);
      }
    }, {
      key: "_allDistMargin",
      value: function _allDistMargin(t, i, n, e) {
        t.children.sort(e);
        var h = this.toBBox,
            a = r(t, 0, i, h),
            o = r(t, n - i, n, h);
        var l = c(a) + c(o);

        for (var _e4 = i; _e4 < n - i; _e4++) {
          var _i6 = t.children[_e4];
          s(a, t.leaf ? h(_i6) : _i6), l += c(a);
        }

        for (var _e5 = n - i - 1; _e5 >= i; _e5--) {
          var _i7 = t.children[_e5];
          s(o, t.leaf ? h(_i7) : _i7), l += c(o);
        }

        return l;
      }
    }, {
      key: "_adjustParentBBoxes",
      value: function _adjustParentBBoxes(t, i, n) {
        for (var _e6 = n; _e6 >= 0; _e6--) {
          s(i[_e6], t);
        }
      }
    }, {
      key: "_condense",
      value: function _condense(t) {
        for (var _i8, _n5 = t.length - 1; _n5 >= 0; _n5--) {
          0 === t[_n5].children.length ? _n5 > 0 ? (_i8 = t[_n5 - 1].children, _i8.splice(_i8.indexOf(t[_n5]), 1)) : this.clear() : h(t[_n5], this.toBBox);
        }
      }
    }]);

    return _class;
  }();
});